import {
  Grid,
  LinearProgress,
  makeStyles,
  Typography,
  withStyles,
} from "@material-ui/core";
import clsx from "clsx";
import { formatNumber } from "utils";

const useStyle = makeStyles({
  container: { maxHeight: 22 },
  label: {
    position: "relative",
    top: -21,
    width: "100%",
    textAlign: "center",
    fontSize: "0.875rem",
  },
});

export const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 22,
    borderRadius: 5,
    marginTop: "0.5rem",

    "&.complete .MuiLinearProgress-bar": {
      backgroundColor: theme.palette.success.main,
    },
  },
  bar: {
    borderRadius: 5,
  },
}))(LinearProgress);

const ContractCardProgress = ({ value }: { value: number }) => {
  const classes = useStyle();
  const progress = value >= 100 ? 100 : value;

  return (
    <Grid className={classes.container}>
      <BorderLinearProgress
        className={clsx({ complete: value >= 100 })}
        variant="determinate"
        value={progress}
      />
      <Typography
        className={classes.label}
        style={{ color: value > 50 ? "#FFFFFF" : "" }}
      >
        {formatNumber(value)}%
      </Typography>
    </Grid>
  );
};

export default ContractCardProgress;
